var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"pt-message-table-item"},[_c('td',{ref:"td",style:({width:_vm.tdMaxWidth?(_vm.tdMaxWidth+'px'):'auto'})},[_vm._v(_vm._s(_vm.label)+"：")]),_c('td',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }